
import OpinionApi from './src/OpinionResources'
import OpinionProjectApi from './src/OpinionProjects'
import OpinionCommentApi from './src/OpinionComments'




let apis = {
   OpinionApi,
   OpinionProjectApi,
   OpinionCommentApi
};

export default apis;
